import type { FullShipment, PropsWithClassName } from '@fv/client-types'

import InfoBox from '@/components/InfoBox'
import { List, ListItem } from '@/components/List'

type Props = PropsWithClassName<{
  load?: Pick<FullShipment, 'routeGuide' | 'status'>
}>

export const RouteGuideBlockedBanner = ({ className, load }: Props) => {
  const blockers = load?.routeGuide?.blockers

  if (load?.status !== 'pending' || !blockers?.length) return null

  return (
    <div className={className}>
      <InfoBox icon="exclamation-triangle">
        <p className="mb-0">
          The route guide didn't run because this shipment is missing
          information required to book:
        </p>
        <List className="border-t border-fv-gray mt-2">
          {blockers.map(blocker => (
            <ListItem bulleted key={blocker} condensed>
              {blocker}
            </ListItem>
          ))}
        </List>
      </InfoBox>
    </div>
  )
}
